module.exports = __webpack_public_path__ + "static/media/Dinner.5e79acd3.png";